export enum IssuerType {
    SECURITIZATION = 'SECURITIZATION',
    FIDC = 'FIDC'
}